import { IMenuItem } from '../../models/menu.model';
import { setupMenu } from './setup.menu';

const _superAdminMenu: IMenuItem[] = [ 
  {
    label: 'Account Reconciliations',
    path: 'account-recon',
    icon: 'fa fa-book',
  },
  {
    label: 'Candidates',
    path: 'candidates',
    icon: 'fa fa-users',
  },
  {
    label: 'Agents',
    path: 'agents',
    icon: 'fa fa-users',
  },
  {
    label: 'Agent Staging',
    path: 'agent-staging',
    icon: 'fa fa-users',
  },
  {
    label: 'Recalculate Agent License Expiry',
    path: 'patch-license',
    icon: 'fa fa-users',
  },
  {
    label: 'Batch Operations',
    path: 'batch',
    icon: 'fa fa-users',
  },
  { label: `Batch Candidate Update`, path: 'batch-candidate-update' },
  { label: `Batch Company Payment Update`, path: 'batch-company-payment-update' },
  { label: `Agent Staging Migration`, path: 'agent-staging-migration' },
];

export const superAdminMenu: IMenuItem[] = [
  setupMenu,
  ..._superAdminMenu.map((x) => ({ ...x, path: '/super/' + x.path })),
];
